import { Typography, Link, TypographyProps, LinkProps } from '@mui/material';

interface CustomFilterInfoTextProps {
  typographyProps?: TypographyProps;
  linkProps?: LinkProps;
}

export const CUSTOM_FILTER_HELP_CENTER_LINK =
  'https://helpcenter.enterpret.com/en/articles/8464101#h_843cbc0cd5';

export const CustomFilterInfoText = ({
  typographyProps,
  linkProps,
}: CustomFilterInfoTextProps) => {
  return (
    <Typography {...typographyProps}>
      Saving Custom Filters can help quickly find and re-use a set of filters
      across Dashboards, Quantify and Search.{' '}
      <Link href={CUSTOM_FILTER_HELP_CENTER_LINK} {...linkProps}>
        Learn more
      </Link>
    </Typography>
  );
};
